import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { push } from 'connected-react-router';
import { bool, objectOf, string } from 'prop-types';

import FormWrapper from '~components/FormWrapper';
import LoadingWrapper from '~components/LoadingWrapper';
import { useSimulationQueryParams } from '~app/hooks/useSimulationQueryParams';
import SimulationActions from '~redux/Simulation/actions';
import { buildMainPath } from '~utils/path';
import { addPrefix } from '~utils/string';

import { FINANCIAL_INFO } from '../IncomesForm/constants';

import {
  getFormConfiguration,
  getIdentityInitialValues,
  mapInitialValues,
  postLaborInfoMapper
} from './utils';
import styles from './styles.module.scss';
import LaborForm from './LaborForm';

const LaborInformation = ({ incumbent, nextStep, currentInfo, stepTarget, loading }) => {
  const [laborSituation, setLaborSituation] = useState(currentInfo?.employmentSituation);
  const dispatch = useDispatch();
  const { quickCode, kind } = useParams();
  const formConfig = getFormConfiguration;
  const queryParams = useSimulationQueryParams();
  const handleSubmit = values => {
    dispatch(
      SimulationActions.setSimulationInfo(addPrefix(incumbent, FINANCIAL_INFO), {
        employmentSituation: values.laborSituation,
        incomes: values.monthlyIncomes,
        emittedInvoicesLastYear: values.emittedInvoicesLastYear,
        jobStartDate: values.jobStartDate
      })
    );
    dispatch(
      SimulationActions.changeIncumbent({
        quickCode,
        values: postLaborInfoMapper(values, incumbent, stepTarget),
        postSuccessAction: () => dispatch(push(buildMainPath(quickCode, nextStep, kind)))
      })
    );
  };

  return (
    <LoadingWrapper loading={loading}>
      <div className={styles.container}>
        <FormWrapper
          form={LaborForm}
          initialValues={currentInfo ? mapInitialValues(currentInfo) : getIdentityInitialValues(queryParams)}
          validationSchema={formConfig.validationSchema(laborSituation)}
          setLaborSituation={setLaborSituation}
          onSubmit={handleSubmit}
        />
      </div>
    </LoadingWrapper>
  );
};

LaborInformation.propTypes = {
  loading: bool.isRequired,
  currentInfo: objectOf(string),
  incumbent: string,
  nextStep: string,
  stepTarget: string
};

export default LaborInformation;
